import React from "react";
import { Carousel } from "../../components/client/Carousel";
// import { Featured } from "../../components/client/Featured";
import { Categories } from "../../components/client/Categories";
import { FeaturedProduct } from "../../components/client/FeaturedProduct";
import { Offer } from "../../components/client/Offer";
import { RecentProduct } from "../../components/client/RecentProduct";
import { Vendor } from "../../components/client/Vendor";
import { RecentPost } from "../../components/client/RecentPost";

export const HomePage = () => {
  return (
    <>
      <Carousel />
      {/* <Featured /> */}
      <Categories />
      <FeaturedProduct />
      <Offer />
      <RecentProduct />
      <RecentPost />
      <Vendor />
    </>
  );
};
